/**
 * Helpers for CrudConfig `detailTitle` — the human subtitle under
 * "<Singular> details" in the detail panel. Without one, the panel falls
 * back to the raw record id.
 */

/** Join the non-empty parts with " · ". Returns null when nothing is left so
 *  the panel's built-in fallback chain still gets a turn. */
export function joinTitle(...parts: unknown[]): string | null {
  const out = parts
    .filter((p) => (typeof p === 'string' && p.trim() !== '') || typeof p === 'number')
    .map((p) => String(p).trim());
  return out.length ? out.join(' · ') : null;
}

/** Read a label off a ref that may be populated (object) or a bare id
 *  (string). Bare ids yield null — they are no more readable than the
 *  record's own id. */
export function refField(ref: unknown, key: string): unknown {
  return ref && typeof ref === 'object' ? (ref as Record<string, unknown>)[key] : null;
}
